import {
  CREATE_CONTACT_LOG_REQUEST,
  CREATE_CONTACT_LOG_SUCCESS,
  CREATE_CONTACT_LOG_FAILURE,
  FETCH_CONTACT_LOGS_REQUEST,
  FETCH_CONTACT_LOGS_SUCCESS,
  FETCH_CONTACT_LOGS_FAILURE,
  UPDATE_CONTACT_LOG_REQUEST,
  UPDATE_CONTACT_LOG_SUCCESS,
  UPDATE_CONTACT_LOG_FAILURE,
  DELETE_CONTACT_LOG_REQUEST,
  DELETE_CONTACT_LOG_SUCCESS,
  DELETE_CONTACT_LOG_FAILURE,
} from "../actions/types";

const initialState = {
  logs: [],
  loading: false,
  error: null,
  message: "",
  pagination: {
    total: 0,
    page: 1,
    size: 10,
    pages: 1,
  },
};

export default function contactLogReducer(state = initialState, action) {
  switch (action.type) {

    case FETCH_CONTACT_LOGS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_CONTACT_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        logs: action.payload.results || [],
        pagination: {
          total: action.payload.total,
          page: action.payload.page,
          size: action.payload.size,
          pages: action.payload.pages,
        },
      };

    case FETCH_CONTACT_LOGS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_CONTACT_LOG_SUCCESS:
      return {
        ...state,
        logs: [action.payload, ...state.logs],
        pagination: {
          ...state.pagination,
          total: state.pagination.total + 1,
        },
      };

    case UPDATE_CONTACT_LOG_SUCCESS:
      return {
        ...state,
        logs: state.logs.map((log) =>
          log.contact_log_id === action.payload.contact_log_id
            ? action.payload
            : log
        ),
      };

    case DELETE_CONTACT_LOG_SUCCESS:
      return {
        ...state,
        logs: state.logs.filter(
          (log) => log.contact_log_id !== action.payload
        ),
        pagination: {
          ...state.pagination,
          total:
            state.pagination.total > 0
              ? state.pagination.total - 1
              : 0,
        },
      };

    case CREATE_CONTACT_LOG_REQUEST:
    case UPDATE_CONTACT_LOG_REQUEST:
    case DELETE_CONTACT_LOG_REQUEST:
      return { ...state, loading: true };

    case CREATE_CONTACT_LOG_FAILURE:
    case UPDATE_CONTACT_LOG_FAILURE:
    case DELETE_CONTACT_LOG_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}